var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.7812C20.9543 25.7812 25.7812 20.9543 25.7812 15C25.7812 9.04568 20.9543 4.21875 15 4.21875C9.04568 4.21875 4.21875 9.04568 4.21875 15C4.21875 20.9543 9.04568 25.7812 15 25.7812Z",
    fill: "#FFA500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15 6.5625C16.208 6.5625 17.1909 5.64516 17.3184 4.47141C16.5712 4.30781 15.7964 4.21875 15 4.21875C9.04547 4.21875 4.21875 9.04547 4.21875 15C4.21875 15.7964 4.30781 16.5712 4.47141 17.3184C5.64562 17.1909 6.5625 16.208 6.5625 15C6.5625 10.3477 10.3477 6.5625 15 6.5625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.5287 12.6816C24.3545 12.8091 23.4376 13.7921 23.4376 15.0001C23.4376 19.6524 19.6524 23.4376 15.0001 23.4376C13.7921 23.4376 12.8091 24.3549 12.6816 25.5287C13.4288 25.6923 14.2037 25.7813 15.0001 25.7813C20.9546 25.7813 25.7813 20.9546 25.7813 15.0001C25.7813 14.2037 25.6923 13.4288 25.5287 12.6816Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.4375C19.6599 23.4375 23.4375 19.6599 23.4375 15C23.4375 10.3401 19.6599 6.5625 15 6.5625C10.3401 6.5625 6.5625 10.3401 6.5625 15C6.5625 19.6599 10.3401 23.4375 15 23.4375Z",
    fill: "#4CCFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05371 10.981C7.93402 9.24711 9.36559 7.83805 11.1159 6.98633",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.67188V15L19.4531 18.9844",
    stroke: "#9C34C2",
    strokeWidth: 4.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.4062C15.7767 16.4062 16.4062 15.7767 16.4062 15C16.4062 14.2233 15.7767 13.5938 15 13.5938C14.2233 13.5938 13.5938 14.2233 13.5938 15C13.5938 15.7767 14.2233 16.4062 15 16.4062Z",
    fill: "#FFA500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.04addd82c38cd22c1c2f60114b65b69c.svg";
export { ForwardRef as ReactComponent };